export function isInternalEmail(email?: string) {
	return email?.endsWith('@trycents.com') ?? false;
}
